import { Action, OperationType } from '../../../dispatcher/Types';

export const toastNotifications: Action = [{
  moduleName: 'ToastNotifications',
  name: 'addNotification',
  args: ['notificationData']
}];

export const executeToastNotificationsLink: Action = [{
  name: 'setFilterData',
  type: OperationType.action
}, {
  moduleName: 'Dashboard',
  name: 'enableClearAllFiltersButton'
}];

/**
 * Posts filters requests with filters as params
 */
export const executeFilterRequest: Action = [{
  data: {
    filterType: 'search'
  },
  type: OperationType.data
}, {
  data: {
    template: {
      bind: {
        params: '{filterParams}'
      }
    }
  },
  name: 'triggerSearch',
  type: OperationType.action
}];

export const executeNotificationRemoval: Action = [{
  moduleName: 'ToastNotifications',
  name: 'removeNotificationFromList',
  args: ['notification']
}];
